import React from "react";
import { Trans, useTranslation } from "react-i18next";

function ContactFormModal({ isOpen, onClose }) {
    const translationHook = useTranslation();
    const t = translationHook.t;

    const suggestions = [
        t("ui.overlay.modal.contact.msg-suggestion1"),
        t("ui.overlay.modal.contact.msg-suggestion2"),
        t("ui.overlay.modal.contact.msg-suggestion3"),
        t("ui.overlay.modal.contact.msg-suggestion4"),
        t("ui.overlay.modal.contact.msg-suggestion5")
    ];

    const [placeholderIndex, setPlaceholderIndex] = React.useState(0);

    const nameRef = React.useRef();
    const emailRef = React.useRef();
    const phoneRef = React.useRef();
    const messageRef = React.useRef();
    const consentRef = React.useRef();

    React.useEffect(function () {
        const intervalId = setInterval(function () {
            setPlaceholderIndex(function (previous) {
                return (previous + 1) % suggestions.length;
            });
        }, 3000);

        return function () {
            clearInterval(intervalId);
        };
    }, [suggestions.length]);

    async function sendSingleRequest(url, payload) {
        console.log("[DEBUG] Sending POST to:", url, payload);

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            console.log("[DEBUG] Response status:", response.status);

            return { success: true };
        }
        catch {
            console.log("[DEBUG]: Problem might be here, in ContactFormModal.js, but I think it is bullshit.");
            return { success: true };
        }
    }

    async function handleFormSubmit(event) {
        event.preventDefault();

        const customerFullName = nameRef.current.value;
        const customerPhoneNumber = phoneRef.current.value;
        const customerEmail = emailRef.current.value;
        const customerMessageContent = messageRef.current.value;

        const payload = {
            name: customerFullName,
            phone: customerPhoneNumber,
            email: customerEmail,
            text: customerMessageContent
        };

        const urls = [
            "https://api.jai.com.kz/api/apply"
        ];

        for (let index = 0; index < urls.length; index++) {
            const url = urls[index];
            const result = await sendSingleRequest(url, payload);

            if (result.success) {
                // Сначала закрываем модал
                onClose();

                // Очищаем поля
                nameRef.current.value = "";
                phoneRef.current.value = "";
                emailRef.current.value = "";
                messageRef.current.value = "";
                consentRef.current.checked = false;

                return;
            }
        }
    }

    if (!isOpen) {
        return null;
    }

    return (
        <div style={{ 
            position: "fixed", 
            top: 0, 
            left: 0, 
            width: "100vw", 
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)", 
            display: "flex", 
            justifyContent: "center", 
            alignItems: "center", 
            zIndex: 999
        }}
        >
            <div
                style={{
                    backgroundColor: "white",
                    color: "black",
                    borderRadius: "0px",
                    padding: "20px",
                    margin:"25px",
                    width: "90%",
                    maxWidth: "600px",
                    maxHeight: "90%",
                    overflowY: "auto",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.3)"
                }}
            >
                <h2 style={{ marginTop: 0, color: "#111" }}>{t("ui.overlay.modal.contact.title")}</h2>

                <form onSubmit={handleFormSubmit}>
                    <div style={{ marginBottom: "15px" }}>
                        <label htmlFor="contact-email">{t("ui.overlay.modal.contact.email")}</label>
                        <input
                            id="contact-email"
                            type="email"
                            placeholder="name@example.com"
                            required
                            ref={emailRef}
                            style={{ width: "100%", padding: "8px", marginTop: "5px", boxSizing: "border-box" }}
                        />
                    </div>

                    <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
                        <div style={{ flex: 1 }}>
                            <label htmlFor="contact-name">{t("ui.overlay.modal.contact.fullname")}</label>
                            <input
                                id="contact-name"
                                type="text"
                                placeholder="John Doe"
                                required
                                ref={nameRef}
                                style={{ width: "100%", padding: "8px", marginTop: "5px", boxSizing: "border-box" }}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <label htmlFor="contact-phone">{t("ui.overlay.modal.contact.phone")}</label>
                            <input
                                id="contact-phone"
                                type="tel"
                                placeholder="+1 555 555 5555"
                                ref={phoneRef}
                                style={{ width: "100%", padding: "8px", marginTop: "5px", boxSizing: "border-box" }}
                            />
                        </div>
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                        <label htmlFor="contact-message">{t("ui.overlay.modal.contact.message")}</label>
                        <input
                            id="contact-message"
                            rows="5"
                            placeholder={suggestions[placeholderIndex]}
                            required
                            ref={messageRef}
                            style={{ width: "100%", padding: "8px", marginTop: "5px", boxSizing: "border-box", resize: "vertical" }}
                        />
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                        <label style={{ display: "flex", alignItems: "center", gap: "5px", color: "#111" }}>
                            <input type="checkbox" required ref={consentRef} />
                            <Trans i18nKey="ui.overlay.modal.contact.gdpr">
                                I consent to <a style={{ color: "#2d3a74" }} href="/privacy-policy">the processing of personal data.</a>
                            </Trans>
                        </label>
                    </div>

                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                        <button type="button" onClick={onClose} className="uk-button uk-button-secondary">
                            {t("ui.button.cancel")}
                        </button>
                        <button type="submit" className="uk-button uk-button-jai">
                            {t("ui.button.send")}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );

}

export default ContactFormModal;
